import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';

import './services/applicationApi';

document.addEventListener('DOMContentLoaded', (event) => {
  ReactDOM.render(<App />, document.getElementById('root'));
});
